import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
  orders: [],
  order: null,
  loading: false,
  error: null,
  orderStatusLoading: false,
};

const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    loadOrdersRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadOrdersSuccess(state, action: any) {
      state.loading = false;
      state.error = null;
      state.orders = action?.payload?.results;
      state.paginationOption = {
        page: action.payload?.page,
        pageSize: action.payload?.pageSize,
        totalItems: action.payload?.totalItems,
        numberOfPages: action.payload?.numberOfPages,
      };
    },
    loadOrdersFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
    loadOrderRequested(state, action: PayloadAction<{}>) {
      state.orderLoading = true;
      state.error = null;
    },
    loadOrderSuccess(state, action: PayloadAction<{ result: any }>) {
      state.orderLoading = false;
      state.error = null;
      state.order = action.payload.result;
    },
    loadOrderFail(state, action: PayloadAction<{}>) {
      state.orderLoading = false;
      state.error = action.payload;
    },
    updateStatusRequested(
      state,
      action: PayloadAction<{
        orderId: any;
        statusId: any;
        description?: string;
      }>
    ) {
      state.orderStatusLoading = true;
      state.error = null;
    },
    updateStatusSuccess(state, action: PayloadAction<{ result: any }>) {
      state.orderStatusLoading = false;
      state.error = null;
      state.updateStatus = action?.payload.result;
    },
    updateStatusFail(state, action: PayloadAction<{}>) {
      state.orderStatusLoading = false;
      state.error = action.payload;
    },
    deleteOrderRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    deleteOrderSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.deleteOrder = action.payload;
    },
    deleteOrderFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
    loadorderStatusesRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadorderStatusesSuccess(state, action: PayloadAction<{ result: any }>) {
      state.loading = false;
      state.error = null;
      state.orderStatuses = action.payload.result;
    },
    loadorderStatusesFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  loadOrdersRequested,
  loadOrdersSuccess,
  loadOrdersFail,
  loadOrderRequested,
  loadOrderSuccess,
  loadOrderFail,
  updateStatusSuccess,
  updateStatusRequested,
  updateStatusFail,
  deleteOrderRequested,
  deleteOrderSuccess,
  deleteOrderFail,
  loadorderStatusesFail,
  loadorderStatusesRequested,
  loadorderStatusesSuccess,
} = ordersSlice.actions;

export default ordersSlice.reducer;
